import { KSpan } from "kahuna-base-react-components"
import React, { SetStateAction } from "react"
import { Link, useLocation } from "react-router-dom"

const NavListElement = ({
  iconPath,
  text,
  bRadius,
  bgColor,
  index,
  selectedIndex,
  setSelectedIndex,
  href
}: {
  iconPath: string
  text: string
  bgColor: string
  bRadius: number
  index: number
  selectedIndex: number
  setSelectedIndex: React.Dispatch<SetStateAction<number>>
  href: string
}) => {
  const onClickEvent = () => {
    setSelectedIndex(index)
  }

  // Read off the router, so a page reached from anywhere else (an overview card, a link in a message) is the
  // one marked here too, and its sub pages (/catalog/release-plan) keep their section marked.
  const { pathname } = useLocation()
  const selected = pathname === href || pathname.startsWith(`${href}/`)

  return (
    <Link to={href} className="group" data-testid={`nav-${text.toLowerCase()}`}>
      <div onClick={onClickEvent} className={`w-auto flex flex-row justify-start items-center`}>
        <div
          className="flex group-hover:!bg-[#f0f0f0]"
          style={{
            backgroundColor: selected ? "#f3f3f3" : bgColor,
            borderRadius: 10,
            padding: "8px 10px",
            transition: "0.4s"
          }}
        >
          <img src={iconPath} className="mr-2" />
          <KSpan text={text} color={selected ? "#000" : "#666"} fontWeight={500} />
        </div>
      </div>
    </Link>
  )
}

export default NavListElement
